var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlignCenterV(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 100 100",
    viewBox: "0 0 100 125",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1.2346
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(90)",
    x: 19.908,
    y: -81.779,
    width: 85.185,
    height: 24.691
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(90)",
    x: 39.66,
    y: -42.913,
    width: 45.679,
    height: 24.691
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(90)",
    x: 58.179,
    y: -95.062,
    width: 8.642,
    height: 90.123
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlignCenterV);
export default __webpack_public_path__ + "static/media/align-center-v.fa20497edfce5c56a8f02c5570c98d34.svg";
export { ForwardRef as ReactComponent };